import { useClientTranslations } from "../../lib/i18n/client";
import type { EducationContent } from "../../services/educationService";
import styles from "./ResumeCard.module.css";

interface ResumeCardProps {
	content: EducationContent;
}

export function ResumeCard({ content }: ResumeCardProps) {
	const { t } = useClientTranslations("education");

	return (
		<button type="button" className={styles.card}>
			<div className={styles.thumbnailArea} aria-hidden="true">
				<div className={styles.playIcon}>
					<svg
						viewBox="0 0 24 24"
						fill="currentColor"
						aria-label="Play"
						role="img"
					>
						<polygon points="6,4 20,12 6,20" />
					</svg>
				</div>
			</div>
			<div className={styles.content}>
				<div className={styles.tagRow}>
					<img
						src={`/images/education/icon-${content.contentType}.svg`}
						alt=""
						className={styles.tagIcon}
					/>
					<span className={styles.tagText}>
						{t(`contentTypes.${content.contentType}`)}
					</span>
				</div>
				<h3 className={styles.title}>{content.title}</h3>
				<div className={styles.progressSection}>
					<div className={styles.progressTrack}>
						<div
							className={styles.progressFill}
							style={{ width: `${(content.progress ?? 0) * 100}%` }}
						/>
					</div>
					<span className={styles.timeLabel}>
						{t("resume.progressLabel", {
							current: content.currentTime,
							total: content.duration,
						})}
					</span>
				</div>
			</div>
		</button>
	);
}
